import './intro-wrapper.scss';

import { ReactNode } from 'react';
import classNames from 'classnames';
import { Power1 } from 'gsap';

import LineAnimation from '@/services/animations/LineAnimation';

import CustomLink from '@/components/CustomLink';
import IllustrationLineBottom from '@/components/lines/IllustrationLineBottom';
import IllustrationLineTop from '@/components/lines/IllustrationLineTop';
import Logo from '@/components/logo/Logo';

import authImage from '@/assets/images/illustrations/auth.png';

interface IntroWrapperProps {
	className?: string;
	image?: string;
	children?: ReactNode;
	dataPrivate?: boolean | string;
}

const IntroWrapper = ({
	className,
	image = authImage,
	children,
	dataPrivate,
}: IntroWrapperProps) => {
	return (
		<main className={classNames('main intro-wrapper', className)} data-private={dataPrivate}>
			<div className="illustration-panel">
				<CustomLink to="/" className="logo-link">
					<Logo className="logo-image" />
				</CustomLink>
				<div className="illustration-image-wrap">
					<LineAnimation
						lineId="#illustration-line-top"
						duration={1}
						delay={0}
						ease={Power1.easeIn}
					>
						<IllustrationLineTop className="illustration-line-top" />
					</LineAnimation>
					<img src={image} className="illustration-image" alt="illustration" />
					<LineAnimation
						lineId="#illustration-line-bottom"
						duration={1}
						delay={1}
						ease={Power1.easeIn}
						drawSVG="100% 100%"
					>
						<IllustrationLineBottom className="illustration-line-bottom" />
					</LineAnimation>
				</div>
			</div>
			{children && (
				<div className="intro-content">
					<CustomLink to="/" className="logo-link">
						<Logo className="logo-image" />
					</CustomLink>
					<div className="intro-content-wrap">{children}</div>
				</div>
			)}
		</main>
	);
};

export default IntroWrapper;
